import {login, logout} from '@/api/sys/authentication/login'
import Common from '@/utils/common'

export default {
  state: {
    menus: undefined,
    refushStatus:true //刷新状态，新增结算单后返回首页用
  },
  getters: {
    menus: state => state.menus,
    refushStatus: state => state.refushStatus
  },
  mutations: {
    INIT_MENU: (state, menus) => {
      state.menus = menus
    },
    INIT_refushStatus: (state, refushStatus) => {
      state.refushStatus = refushStatus
    },
  },
  actions: {
    initMenus({commit}, userId) {
      return new Promise((resolve, reject) => {
        Common.httpPost("获取管理后台菜单", "admin/system/function/getAdminMenus").then(res => {
          commit('INIT_MENU', res.data);
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    initRefushStatusessage({commit}, refushStatus) {
      return new Promise((resolve) => {
        commit('INIT_refushStatus', refushStatus);
        resolve();
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/menu.js